export const forBusiness_realEstate_listing = [
	{
		icon: '🏡',
		title: 'listingsData_title1',
		subtitle: 'listingsData_subtitle1',
	},
	{
		icon: '💁‍♀️',
		title: 'listingsData_title2',
		subtitle: 'listingsData_subtitle2',
	},
	{
		icon: '🪴',
		title: 'listingsData_title3',
		subtitle: 'listingsData_subtitle3',
	},
	{
		icon: '🖼',
		title: 'listingsData_title4',
		subtitle: 'listingsData_subtitle4',
	},
	{
		icon: '✌️',
		title: 'listingsData_title5',
		subtitle: 'listingsData_subtitle5',
	},
];
